angular.module('app.factories').factory('phasesListFilterFactory', ($translate, $state, $log, listFilter) => {
    const phasesListFilter = listFilter;

    phasesListFilter
        .setAttributes({
            name: 'phasesListFilter',
            providers: [
                'usersOptions',
                'phaseStatusOptions',
                'projectTypeOptions',
                'serviceWorkOptions',
                'serviceTypeOptions',
                'transportTypeOptions',
                'packagingMethodOptions',
                'clientOptionsForPhasesFilter',
                'locationOptions',
                'countryOptions',
            ],
        })
        .setFields({
            // row 1
            filter: {
                type: 'text',
                class: 'uk-width-medium-6-10',
                label: $translate.instant('search'),
                default: '',
            },
            search_in: {
                type: 'checkbox-list',
                class: 'uk-width-medium-4-10',
                label: $translate.instant('search_in'),
                names: [
                    { name: 'name', label: $translate.instant('phases.name') },
                    { name: 'symbol', label: $translate.instant('phases.symbol') },
                    { name: 'client.name', label: $translate.instant('phases.client_id') },
                ],
                default: { name: true },
            },

            // row 2
            owner_id: {
                type: 'multiuserlist',
                operator: 'in',
                class: 'uk-width-medium-4-10',
                label: $translate.instant('phases.owner_id'),
                optionsProvider: 'usersOptions',
                options: [],
                default: '',
            },
            manager_id: {
                type: 'multiuserlist',
                operator: 'in',
                class: 'uk-width-medium-4-10',
                label: $translate.instant('phases.manager_id'),
                optionsProvider: 'usersOptions',
                options: [],
                default: '',
            },
            status_id: {
                type: 'multilist',
                operator: 'in',
                class: 'uk-width-medium-2-10',
                label: $translate.instant('phases.status_id'),
                optionsProvider: 'phaseStatusOptions',
                options: [],
                default: '',
            },

            // row 3
            'project.type': {
                type: 'multilist',
                operator: 'in',
                class: 'uk-width-medium-5-10',
                label: $translate.instant('phases.type'),
                maxItems: 4,
                optionsProvider: 'projectTypeOptions',
                options: [],
                default: '',
            },
            'project.client_id': {
                type: 'clientslist',
                class: 'uk-width-medium-5-10',
                label: $translate.instant('phases.client_id'),
                optionsProvider: 'clientOptionsForPhasesFilter',
                options: [],
                operator: '=',
                default: '',
            },

            // row 4
            date_from: {
                type: 'date',
                class: 'uk-width-medium-5-10',
                label: $translate.instant('phases.date_from'),
            },
            date_to: {
                type: 'date',
                class: 'uk-width-medium-5-10',
                label: $translate.instant('phases.date_to'),
            },

            // row 5
            service_work_id: {
                type: 'multilist',
                operator: 'in',
                class: 'uk-width-medium-1-4',
                label: $translate.instant('phases.service_work_id'),
                optionsProvider: 'serviceWorkOptions',
                options: [],
                default: '',
            },
            service_type_id: {
                type: 'multilist',
                operator: 'in',
                class: 'uk-width-medium-1-4',
                label: $translate.instant('phases.service_type_id'),
                optionsProvider: 'serviceTypeOptions',
                options: [],
                default: '',
            },
            transport_type_id: {
                type: 'multilist',
                operator: 'in',
                class: 'uk-width-medium-1-4',
                label: $translate.instant('phases.transport_type_id'),
                optionsProvider: 'transportTypeOptions',
                options: [],
                default: '',
            },
            packaging_method_id: {
                type: 'multilist',
                operator: 'in',
                class: 'uk-width-medium-1-4',
                label: $translate.instant('phases.packaging_method_id'),
                optionsProvider: 'packagingMethodOptions',
                options: [],
                default: '',
            },
            // row 6
            location_id: {
                type: 'multilist',
                operator: 'in',
                class: 'uk-width-medium-1-2',
                label: $translate.instant('phases.location_id'),
                optionsProvider: 'locationOptions',
                options: [],
                default: '',
            },
            country_id: {
                type: 'multilist',
                operator: 'in',
                class: 'uk-width-medium-1-2',
                label: $translate.instant('phases.country_id'),
                optionsProvider: 'countryOptions',
                options: [],
                default: '',
            },
        })
        .onRefresh(() => {
            const filterParams = phasesListFilter.getValues(true);
            phasesListFilter.updateClientsOptions('project.client_id');
            $log.debug('--> apply filter', filterParams);
            $state.applyFilter(filterParams);
        })
        .ready();

    return phasesListFilter;
});
